module.exports = __webpack_public_path__ + "img/secretario.41d52984.jpg";